import axios from "@axios";


export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((item) => ({
        data: loitemgs.data,
        old_data: item.old_data,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {

    //getAll Retrieves all rules for the grid table view.
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/rule`, {params});

      if (!data) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    //getRule Retrieves a specific rule given its ID
    async getRule({ _ }, id) {
        const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/rule/${id}`)
        return data;
      },
    //add Creates a new rule.
    async add(_, params) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/rule`, params);

      return data;
    },
     //edit Updates an existing rule.
    async edit(_, { id, params }) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/rule/${id}`, params);

      return data;
    },
     //delete Deletes an existing rule.
    async delete(_, id) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/rule/delete/${id}`);

      return data;
    },

    //clear Clears the stored list of rules in the state.
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
